import React from 'react';
import './RecommendationsTable.scss';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { Recommendation } from '../../../../types/apiGeneratedTypes';
import { useDispatch } from 'react-redux';
import {
  setRecommendationToEdit,
  setRecommendationToDelete,
  changeDeleteRecommendationModalVisibility,
  changeModalVisibility,
  setRecommendationToView
} from '../../../../store/recommendationSlice';

interface IProps {
  recommendationData: Recommendation;
  recommendationsList: Recommendation[];
}

const RecommendationsTableMedicalLibraryRow: React.FC<IProps> = ({
  recommendationData,
  recommendationsList
}) => {
  const dispatch = useDispatch();
  const onOptionClick = async (id: number, action: string) => {
    if (action === 'edit') {
      dispatch(setRecommendationToEdit(recommendationData));
      dispatch(changeModalVisibility(true));
    }
    if (action === 'delete') {
      dispatch(setRecommendationToDelete(recommendationData));
      dispatch(changeDeleteRecommendationModalVisibility(true));
      
    }
    if (action === 'view') {
      dispatch(setRecommendationToView(recommendationData));
    }
  };

  return (
    <div className='table-row recommendations-table-row'>
      <div className='test-image'>
        <img
          src={recommendationData.image_url ?? recommendationData.image}
          alt='recommendation'
          width='100'
          height='100'
        />
      </div>
      <div className='recommendation-category'>
        {recommendationData.category?.name || '-'}
      </div>
      <div className='test-title'>{recommendationData.title}</div>
      <div className='recommendation-description'>
        {recommendationData.description}
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            { key: 'delete', value: 'Delete' },
            { key: 'view', value: 'View' }
          ]}
          id={recommendationData.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default RecommendationsTableMedicalLibraryRow;
